// extracted by mini-css-extract-plugin
export default {"empty-state":"Chart_empty-state__iasW0"};